import React, { useState } from 'react';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import emailjs from '@emailjs/browser';

import "@fontsource/roboto";
import "../../styles/Contact.css";

function Contact() {
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        user_email: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        const templateParams = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            user_email: formData.user_email,
            message: formData.message
        };

        console.log("Sending params:", templateParams);

        emailjs.send(
            'contact_service',
            'contact_form',
            templateParams,
            '1twixCs6K2StYEK0G'
        )
        .then(() => {
            console.log('SUCCESS');
            setFormData({
                firstName: '',
                lastName: '',
                user_email: '',
                message: ''
            });
            setValidated(false);
        })
        .catch((error) => {
            console.log('FAILED...', error);
        });

        setValidated(true);
    };

    return (
        <Container fluid className="ContactContainer" style={{ marginBottom: "3rem" }}>
            <Row className="justify-content-center">
                <Col className="text-center position-relative mb-4">
                    <div className='rectangle'></div>
                    <h1 style={{ fontFamily: 'Roboto', fontWeight: '900', fontSize: '60px', marginBottom: '3rem' }}>
                        Contact
                    </h1>
                </Col>
            </Row>

            <Container className='form-container'>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Form.Group xs={12} lg={6} as={Col} controlId="formGridFirstName">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                placeholder="First name"
                            />
                            <Form.Control.Feedback type="invalid">
                                Please provide a first name
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridLastName">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                placeholder="Last name"
                            />
                            <Form.Control.Feedback type="invalid">
                                Please provide a last name
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>

                    <Form.Group className="mb-3" controlId="formGridEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            required
                            type="email"
                            name="user_email"
                            value={formData.user_email}
                            onChange={handleChange}
                            placeholder="username@example.com"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide an email
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGridMessage">
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                            required
                            as="textarea"
                            rows={5}
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Message"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please write a message
                        </Form.Control.Feedback>
                    </Form.Group>

                    <br />
                    <Button type="submit">Submit</Button>
                </Form>
            </Container>
        </Container>
    );
}

export default Contact;